"use client";

import { strings } from "@perceptron/constants";
import { Command, CommandGroup, CommandItem, CommandList } from "@perceptron/ui/components/command";
import { Icon, IconName } from "@perceptron/ui/components/icon";
import { cn } from "@perceptron/utils/cn";

import { MediaFactory } from "@demo/libs/media-factory";
import { useMediaStore } from "@demo/store/media";
import { useModelStore } from "@demo/store/model";

interface SelectOutputFormatContentProps {
  onClose?: () => void;
}

export const SelectOutputFormatContent = ({ onClose }: SelectOutputFormatContentProps) => {
  const { outputFormat, setOutputFormat, setEnableReasoning } = useModelStore();
  const selectedModel = useModelStore((state) => state.selectedModel);
  const targetMedia = useMediaStore((state) => state.targetMedia);

  const outputFormats = selectedModel.outputFormats;

  return (
    <Command className="p-0">
      <CommandList className="max-h-none overflow-visible rounded-xl p-0">
        <CommandGroup>
          {outputFormats.map((output, index) => {
            const description =
              strings.responseStyle.descriptions[output.value as keyof typeof strings.responseStyle.descriptions];

            const isSupported =
              !!targetMedia && output.capabilities.media.includes(MediaFactory.detectMediaKind(targetMedia));

            if (!isSupported) {
              return null;
            }

            return (
              <CommandItem
                className={cn(
                  "w-full cursor-pointer flex-col items-start rounded-sm p-3",
                  "hover:bg-background-primary",
                  outputFormat.value === output.value && "!bg-background-hover",
                  { "mt-1": index > 0 },
                )}
                disabled={!isSupported}
                key={output.value}
                selected={outputFormat.value === output.value}
                value={output.value}
                onSelect={() => {
                  setOutputFormat(index);
                  if (output.value === "TEXT" || output.value === "CLIP") {
                    if (selectedModel.capabilities.reasoning.supported) {
                      setEnableReasoning(true);
                    }
                  } else {
                    setEnableReasoning(false);
                  }
                  onClose?.();
                }}
              >
                <div className="flex w-full items-center">
                  <span className="body">{output.label}</span>
                  <Icon className="ml-auto h-4 w-4" name={output.icon as IconName} />
                </div>
                <div className="mt-1 legal">{description}</div>
              </CommandItem>
            );
          })}
        </CommandGroup>
      </CommandList>
    </Command>
  );
};
